const baseOrigin = "https://id.es6.vn/";
const baseOriginTest = "http://localhost.es6.vn:8080/";
const crossOrigin = "https://core.api.es6.vn/";
const crossOriginTest = "http://localhost.core.api.es6.vn/";
const timeout = 1000 * 60 * 5;
const isTest = 0;

module.exports = {
    baseOrigin: !isTest ? baseOrigin : baseOriginTest,
    crossOrigin: !isTest ? crossOrigin : crossOriginTest,
    timeout,
};



// WEBPACK FOOTER //
// src/utils/api/node/config.js